import { red } from '@mui/material/colors';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { createStyles, makeStyles } from '@mui/styles';

const useCameraDetailsOverlayStyles = makeStyles(({ shape, spacing, palette }) => {
  return createStyles({
    videoControllsWrapper: {
      zIndex: 15,
      position: 'absolute',
      bottom: 0,
      width: '100%',
      opacity: 0.9,
      '&:hover $videoControllsButtonsWrapper': {
        display: 'flex',
        flexWrap: 'wrap',
      },
    },
    videoControllsWrapperSelected: {
      backgroundColor: `${palette.secondary.main} !important`,
    },
    videoControllsTitle: {
      fontSize: 'small',
      textAlign: 'center',
      alignItems: 'center',
      justifyItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      padding: spacing(0.8),
      backgroundColor: palette.common.black,
      color: palette.common.white,
    },
    videoControllsButtonsWrapper: {
      backgroundColor: palette.common.black,
      justifyContent: 'center',
      display: 'none',
    },
    videoControllsButton: {
      color: palette.common.white,
    },
    publicOffButton: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: `${spacing()} ${spacing()} 0 ${spacing()}`,
      margin: '10px',
      borderRadius: '100%',
      color: palette.common.white,
      zIndex: 1000,
    },
    publicOffConfirmed: {
      backgroundColor: red[500],
    },
    publicOffPending: {
      backgroundColor: palette.warning.main,
    },
    recordingButton: {
      color: red[500],
      borderRadius: '50%',
    },
    smallRecordingButton: {
      paddingBottom: spacing(0.8),
      fontSize: '1rem',
    },
    cameraControlsWrapper: {
      position: 'relative',
      left: '50%',
      transform: 'translate(-50%, 0)',
      maxHeight: spacing(52),
      height: 'fit-content',
      width: spacing(62),
      overflowY: 'scroll',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      borderRadius: shape.borderRadius,
      marginBottom: spacing(),
    },
    cameraControlsFullScreen: {
      maxHeight: `calc(100vh - ${spacing(20)})`,
    },
    cameraControls: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: 'small',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      borderRadius: shape.borderRadius,
      color: palette.common.white,
      height: spacing(10),
      padding: spacing(2),
      marginBottom: spacing(0.6),
    },
    controlsButtonsWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    capabilitiesSelectInput: {
      color: palette.common.white,
      font: 'inherit',
      letterSpacing: 'inherit',
      width: spacing(36),
      [`& .${outlinedInputClasses.input}`]: {
        padding: spacing(1),
        color: palette.common.white,
      },
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: `${palette.common.white} !important`,
      },
      [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: palette.common.white,
      },
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: palette.common.white,
      },
    },
    capabilitiesList: {
      color: palette.common.white,
      backgroundColor: palette.common.black,
      height: spacing(20),
      overflowY: 'scroll',
      '& li:hover': {
        backgroundColor: 'rgba(202, 204, 207, 0.5)',
      },
      '& .Mui-selected:hover': {
        backgroundColor: 'rgba(202, 204, 207, 0.5)',
      },
    },
    capabilitiesSelectIcon: {
      fill: palette.common.white,
    },
    controlText: {
      width: spacing(24),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    irisText: {},
    presetMenuWrapper: {
      position: 'relative',
      left: '40%',
      maxWidth: spacing(53.4),
      maxHeight: spacing(30),
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      borderRadius: shape.borderRadius,
      color: palette.common.white,
      padding: `${spacing(2)} 0`,
      marginBottom: spacing(2),
    },
    presetItemText: {
      width: spacing(40),
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    saveCurrentItem: {
      backgroundColor: palette.common.black,
      position: 'sticky',
      bottom: 0,
      zIndex: 2,
    },
    saveCurrentItemRoot: {
      borderTop: `1px solid ${palette.common.white}`,
    },
    presetItemsWrapper: {
      height: 'auto',
      overflowY: 'scroll',
      paddingBottom: spacing(),
    },
    menuItemText: {
      fontSize: '0.9rem',
    },
    cameraInformationWrapper: {
      position: 'relative',
      left: '40%',
      maxWidth: spacing(70),
      maxHeight: spacing(50),
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      borderRadius: shape.borderRadius,
      color: palette.common.white,
      padding: `${spacing(2)} 0`,
      marginBottom: spacing(),
    },
    lastCommandText: {
      paddingRight: spacing(2),
    },
    locationLabels: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: spacing(5),
      width: '100%',
      paddingTop: spacing(),
      display: 'flex',
      alignItems: 'start',
      backgroundColor: palette.common.black,
    },
    locationDescriptionLabel: {
      backgroundColor: palette.secondary.main,
      padding: `0 ${spacing()}`,
      color: palette.common.black,
    },
    referenceLabel: {
      backgroundColor: palette.success.main,
      padding: `0 ${spacing()}`,
      color: palette.common.white,
    },
    screenLayoutWrapper: {
      position: 'relative',
      left: '50%',
      maxWidth: spacing(50),
      backgroundColor: 'rgba(0, 0, 0)',
      borderRadius: shape.borderRadius,
      color: palette.common.white,
      padding: 0,
      marginBottom: spacing(),
    },
    screenLayoutItem: {
      padding: `${spacing(1.5)} 0`,
    },
    recordCountBadge: {
      backgroundColor: palette.error.main,
      borderRadius: spacing(2.2),
      fontSize: spacing(2.2),
      minWidth: spacing(4.2),
      height: spacing(4.1),
      marginRight: spacing(0.8),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: `0px ${spacing(0.4)}`,
    },
    globeBlockedConfirmed: {
      color: `${palette.error.main} !important`,
    },
    globeBlockedPending: {
      color: `${palette.warning.main} !important`,
    },
  });
});

export default useCameraDetailsOverlayStyles;
